export default __webpack_public_path__ + "static/media/2006-AMcover.05af5202.png";